import { render, staticRenderFns } from "./SensorDesk.vue?vue&type=template&id=2f96beda&scoped=true&"
import script from "./SensorDesk.vue?vue&type=script&lang=ts&"
export * from "./SensorDesk.vue?vue&type=script&lang=ts&"
import style0 from "./SensorDesk.vue?vue&type=style&index=0&id=2f96beda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96beda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon,VSpeedDial,VTooltip})
